import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import { currency } from '@/lib/helper';
import Button from '@/components/@base/button';
import useBottomSheetStore from '@/store/bottom-sheet-store';
import PreInvoice from '@/components/pre-invoice';
import React, { useEffect } from 'react';
import useUserWalletsVouchersStore from '@/store/user-wallets-store';
import useHomeStore from '@/store/home';
import { usePostCreateTransactions } from '@/services/hooks';
import { selectedSegments, selectedVouchers } from '@/services/models/api.models';
import useCommonModalStore from '../../store/common-modal-store';
import UserCanSelectAssets from '@/components/user-can-select-assets';
import cn from '@/lib/clsxm';
import { SIZE_ENUM } from '@/components/@base/@types';
import AddWalletWithId from '@/components/shared/add-wallet-with-id';

const Payment = () => {
  const { setShowBottomSheet, showBottomSheet } = useBottomSheetStore();
  const { setShow } = useCommonModalStore();
  const { segments, usableClientVouchers, isSegmentLoading } = useUserWalletsVouchersStore();
  const { invoice, remainInvoice, setRemainInvoice, isActiveRequest, setIsActiveRequest } =
    useHomeStore();
  const { mutate, isPending } = usePostCreateTransactions();
  const checkUserSelectedAssetsOrDontHaveAssets = () => {
    if (remainInvoice === 0) {
      return true;
    } else if (
      sessionStorage.getItem('walletsIsEmpty') &&
      sessionStorage.getItem('vouchersIsEmpty')
    ) {
      return true;
    } else return !!sessionStorage.getItem('isSelectedVoucherOrWallet');
  };

  const showPreInvoice = () => {
    if (!isActiveRequest && checkUserSelectedAssetsOrDontHaveAssets()) {
      setIsActiveRequest(true);
      const theSelectedSegments: selectedSegments[] = [];
      const theSelectedVouchers: selectedVouchers[] = [];
      segments?.map((s) => {
        if (s.selected && s.usageBalance) {
          theSelectedSegments.push({
            segmentId: s.segmentId,
            amount: s.usageBalance,
          });
        }
      });
      usableClientVouchers?.map((s) => {
        if (s.selected) {
          theSelectedVouchers.push({
            voucherId: s.voucherId,
          });
        }
      });
      mutate(
        {
          selectedSegments: theSelectedSegments,
          selectedVouchers: theSelectedVouchers,
        },
        {
          onSuccess: (res) => {
            setIsActiveRequest(false);
            setShowBottomSheet(true, {
              onDemandClose: false,
              Body: () => <PreInvoice data={res} />,
            });
          },
          onError: () => {
            setIsActiveRequest(false);
          },
        },
      );
    } else if (!sessionStorage.getItem('isSelectedVoucherOrWallet')) {
      setShow(true, {
        center: true,
        onDemandClose: false,
        dialogPanelClassName: 'px-0 pb-0 w-[280px]',
        Body: () => (
          <UserCanSelectAssets
            handleGoToPayment={() => {
              mutate(
                {
                  selectedSegments: [],
                  selectedVouchers: [],
                },
                {
                  onSuccess: (res) => {
                    setIsActiveRequest(false);
                    setShowBottomSheet(true, {
                      onDemandClose: false,
                      Body: () => <PreInvoice data={res} />,
                    });
                  },
                  onError: () => {
                    setIsActiveRequest(false);
                  },
                },
              );
            }}
          />
        ),
      });
    }
  };
  useEffect(() => {
    let selectedSegmentsAndVouchersAmount = 0;
    segments?.map((s) => {
      if (s.selected && s.usageBalance) {
        selectedSegmentsAndVouchersAmount += s.usageBalance;
      } else if (s.selected) {
        selectedSegmentsAndVouchersAmount += s.balance;
      }
    });
    usableClientVouchers?.map((s) => {
      if (s.selected && s.usageBalance) {
        selectedSegmentsAndVouchersAmount += s.usageBalance;
      }
    });
    setRemainInvoice(invoice - selectedSegmentsAndVouchersAmount);
  }, [segments, usableClientVouchers, showBottomSheet, invoice]);
  if (segments.length === 0 && usableClientVouchers.length === 0 && !isSegmentLoading) {
    return <AddWalletWithId showPreInvoice={showPreInvoice} isLoading={isPending} className="fixed bottom-4 right-1/2 translate-x-[50%] z-30 w-full max-w-[448px] px-4"/>
  }
  return (
    <Container className='fixed bottom-0 right-1/2 translate-x-[50%] z-30 flex h-[84px] w-full max-w-[448px] items-center justify-between border-t border-grayLight-50 bg-white p-4 shadow-[0_0_16px_0_#00000040] dark:border-grayDark-800 dark:bg-grayLight-990'>
      <Container center className='w-full flex-col items-start'>
        <Text className='flex gap-1 text-black dark:text-white'>
          {localization.invoiceBalance}{' '}
          <span className={cn('hidden text-grayLight-350', remainInvoice < invoice && 'flex')}>
            (<span className={cn('text-grayLight-350 line-through')}>{currency(invoice)}</span>
            )
          </span>
        </Text>
        <Text className={cn('text-xl text-black dark:text-white')} semiBold>
          {currency(remainInvoice)}{' '}
          <span className='text-xs font-medium'>{localization.rial}</span>
        </Text>
      </Container>
      <Button
        className='text-md whitespace-nowrap rounded-full px-8'
        style={{ height: '52px', width: '184px' }}
        size={SIZE_ENUM.XL}
        onClick={showPreInvoice}
        isLoading={isPending}
        disabled={isPending || showBottomSheet}
      >
        {remainInvoice === 0 ? localization.payment : localization.remainPayment}
      </Button>
    </Container>
  );
};
export default Payment;
